module.exports = __webpack_public_path__ + "static/media/share-alt-solid.d41ec13e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/Resources/Images/share-alt-solid.svg
// module id = 471
// module chunks = 2